import React, { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./Carousel.css";

const Carousel = (props) => {
  const [currentChoice, setCurrentChoice] = useState();

  const handleCurrentChoice = (choice) => {
    setCurrentChoice(choice);
  };

  const items = [];

  const handleDragStart = (e) => e.preventDefault();

  props.data.map((e) => {
    let newImage = (
      <div className="item">
        <img
          src={e.binImage}
          alt="cards"
          onClick={() => handleCurrentChoice(e.id)}
        />
      </div>
    );

    items.push(newImage);
  });

  useEffect(() => {
    props.choice(currentChoice);
  }, [currentChoice]);

  return (
    <div>
      <AliceCarousel mouseTracking touchTracking items={items} />
    </div>
  );
};

export default Carousel;
